import { Modal } from 'antd'
import styled from 'styled-components'
import { mediaMax } from '@/app/styles/breakpoints'

export const ServerModalStyled = styled(Modal)`
  && {
    .ant-modal-content {
      box-shadow: none;
      display: flex;
      flex-direction: column;
      gap: 48px;
    }
    .ant-modal-header {
      margin-bottom: 0;
    }
    .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 16px;
      margin-top: 0;
      .ant-btn {
        margin: 0;
      }
    }
    @media (max-width: 767px) {
      max-width: calc(100vw - 32px);
    }

    ${mediaMax.sm} {
      position: fixed;
      min-width: 100vw;
      height: 100%;
      top: 0;
      left: 0;
      margin: 0;
      display: flex !important;
      flex-direction: column;
      & > div {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }

    .ant-modal-content {
      padding: 20px 16px;
      border-radius: 6px;
      box-shadow: none;
      ${mediaMax.sm} {
        flex: 1;
        padding: 0;
        overflow: auto;
        gap: 40px;
        .ant-modal-body {
          padding: 0 16px;
          flex: 1;
        }
        .ant-modal-footer {
          padding: 24px 16px;
        }
      }
    }

    .ant-modal-header {
      ${mediaMax.sm} {
        height: 88px;
        border-radius: 0;
        margin-bottom: 0;
        box-shadow: 0px 4px 16px 0px rgba(12, 16, 24, 0.12);
        display: flex;
        align-items: center;
        padding: 0 16px 0 64px;
        flex: 0 0 auto;
      }
    }

    .ant-modal-close {
      top: 16px;
      inset-inline-end: 16px;
      ${mediaMax.sm} {
        top: 28px;
        left: 16px;
        right: auto;
      }
    }
  }
`
